import { LocalizedEventData, getRRuleConfiguration } from '@carlito/bookito-client';
import { RRule } from 'rrule';

export default function formatPrice(cost: number, locale = 'de-DE') {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'EUR',
  }).format(cost);
}

export function findOccurrenceForDate(
  targetDate: Date,
  event: Pick<LocalizedEventData, 'occurrences'>
) {
  for (const occurrence of event.occurrences) {
    const startDateTime = new Date(occurrence.startDateTime);

    if (
      startDateTime.getDate() === targetDate.getDate() &&
      startDateTime.getMonth() === targetDate.getMonth() &&
      startDateTime.getFullYear() === targetDate.getFullYear()
    ) {
      return occurrence;
    }

    if (occurrence.repetition) {
      const rruleConfig = getRRuleConfiguration(
        {
          ...occurrence.repetition,
          repeatUntil: occurrence.repetition.repeatUntil
            ? new Date(occurrence.repetition.repeatUntil)
            : undefined,
        },
        {
          dtStart: startDateTime,
        }
      );

      const rule = new RRule(rruleConfig);

      const dates = rule.between(
        new Date(targetDate.getFullYear(), targetDate.getMonth(), targetDate.getDate()),
        new Date(targetDate.getFullYear(), targetDate.getMonth(), targetDate.getDate(), 23, 59, 59),
        true
      );

      if (dates.length > 0) {
        return occurrence;
      }
    }
  }
  return null;
}
